export const WHATSAPP_NUMBER = "393886957133";
export const waLink = (msg) =>
  `https://wa.me/${WHATSAPP_NUMBER}${msg ? `?text=${encodeURIComponent(msg)}` : ""}`;

export const LOGO_NAVY = `${process.env.PUBLIC_URL || ""}/logo-navy.webp`;
export const LOGO_LIGHT = `${process.env.PUBLIC_URL || ""}/logo-light.webp`;

export const SOCIAL = {
  instagram: "https://www.instagram.com/larondinecharter/",
  facebook: "https://www.facebook.com/larondinecharterischia/?locale=it_IT",
};

const A = `${process.env.PUBLIC_URL || ""}/img`;

export const IMG = {
  heroTwilight: `${A}/heroTwilight.webp`,
  rondineCastello: `${A}/rondineCastello.webp`,
  rondineFleet: `${A}/rondineFleet.webp`,
  rondinellaFleet: `${A}/rondinellaFleet.webp`,
  deck: `${A}/deck.webp`,
  cabin: `${A}/cabin.webp`,
  saloon: `${A}/saloon.webp`,
  rondineSepiaSide: `${A}/rondineSepiaSide.webp`,
  rondineSepiaBow: `${A}/rondineSepiaBow.webp`,
  rondineBreakfast: `${A}/rondineBreakfast.webp`,
  rondineCabin2: `${A}/rondineCabin2.webp`,
  rondineStairsCabin: `${A}/rondineStairsCabin.webp`,
  rondineBunk: `${A}/rondineBunk.webp`,
  rondineBathroomShower: `${A}/rondineBathroomShower.webp`,
  rondineBathroomSink: `${A}/rondineBathroomSink.webp`,
  rondineCorridor: `${A}/rondineCorridor.webp`,
  rondinellaCoupleHD: `${A}/rondinellaCoupleHD.webp`,
  rondinellaCastello: `${A}/rondinellaCastello.webp`,
  rondinellaCruise: `${A}/rondinellaCruise.webp`,
  rondinellaAperitivo: `${A}/rondinellaAperitivo.webp`,
  rondinellaSunset: `${A}/rondinellaSunset.webp`,
};

const P = process.env.PUBLIC_URL || "";
export const DEST = {
  ischia: `${P}/dest/ischia.webp`,
  procida: `${P}/dest/procida.webp`,
  capri: `${P}/dest/capri.webp`,
  amalfi: `${P}/dest/amalfi.webp`,
  ponza: `${P}/dest/ponza.webp`,
  palmarola: `${P}/dest/palmarola.webp`,
};

const rondineGallery = [
  IMG.rondineSepiaSide,
  IMG.rondineSepiaBow,
  IMG.deck,
  IMG.rondineBreakfast,
  IMG.saloon,
  IMG.cabin,
  IMG.rondineCabin2,
  IMG.rondineStairsCabin,
  IMG.rondineBunk,
  IMG.rondineBathroomShower,
  IMG.rondineBathroomSink,
  IMG.rondineCorridor,
];

const rondinellaGallery = [IMG.rondinellaCastello, IMG.rondinellaCruise, IMG.rondinellaAperitivo, IMG.rondinellaSunset];

const cruisesIT = {
  overline: "Mini Crociere",
  title: "Più giorni, intorno alle isole",
  desc: "Charter di uno o più giorni a bordo de La Rondine, con pernottamento in cabina e uno chef a vostra disposizione. Ogni mini crociera è personalizzabile in base alle vostre richieste.",
  destinationsLabel: "Destinazioni",
  destinations: [
    { name: "Ischia", img: DEST.ischia },
    { name: "Procida", img: DEST.procida },
    { name: "Capri", img: DEST.capri },
    { name: "Costiera Amalfitana", img: DEST.amalfi },
    { name: "Ponza", img: DEST.ponza },
    { name: "Palmarola", img: DEST.palmarola },
  ],
  boardsLabel: "Formule di soggiorno",
  boards: [
    { name: "B&B", desc: "Pernottamento e prima colazione a bordo." },
    { name: "Mezza pensione", desc: "Colazione e un pasto principale preparati dallo chef." },
    { name: "Pensione completa", desc: "Colazione, pranzo e cena: lo chef pensa a tutto." },
  ],
  img: IMG.saloon,
  cta: "Richiedi una mini crociera",
};

const cruisesEN = {
  overline: "Mini Cruises",
  title: "Several days, open sea",
  desc: "One or multi-day charters aboard La Rondine, sleeping in the cabins with a chef at your service. Every mini cruise is fully customizable to your wishes.",
  destinationsLabel: "Destinations",
  destinations: [
    { name: "Ischia", img: DEST.ischia },
    { name: "Procida", img: DEST.procida },
    { name: "Capri", img: DEST.capri },
    { name: "Amalfi Coast", img: DEST.amalfi },
    { name: "Ponza", img: DEST.ponza },
    { name: "Palmarola", img: DEST.palmarola },
  ],
  boardsLabel: "Board options",
  boards: [
    { name: "B&B", desc: "Overnight stay and breakfast on board." },
    { name: "Half board", desc: "Breakfast and one main meal prepared by the chef." },
    { name: "Full board", desc: "Breakfast, lunch and dinner: the chef takes care of everything." },
  ],
  img: IMG.saloon,
  cta: "Request a mini cruise",
};

export const content = {
  it: {
    nav: { fleet: "Le Barche", itineraries: "Itinerari", story: "Storia", contact: "Contatti", book: "Prenota" },
    hero: {
      overline: "Ischia · Golfo di Napoli",
      titleLines: ["Step aboard.", "Let time slow down."],
      sub: "Ischia Boat Tours & Mini Cruises | La Rondine Charter",
      cta: "Prenota su WhatsApp",
      scroll: "Scopri di più",
    },
    marquee: ["Tour d'Ischia", "Tour condivisi", "Aperitivo al tramonto", "Mini crociere", "Barche in legno", "Snorkeling"],
    fleet: {
      overline: "Charter · Ischia",
      title: "Le nostre barche",
      subtitle: "Scegli la tua imbarcazione e scopri tutte le esperienze che possiamo offrirti.",
      discover: "Scopri le escursioni",
      boats: [
        {
          slug: "rondine",
          name: "La Rondine",
          tag: "22 metri · 1924",
          desc: "Un'imbarcazione d'epoca in legno del 1924, restaurata e curata in ogni dettaglio. Spazi ampi e accoglienti per escursioni giornaliere e mini crociere nel Golfo di Napoli.",
          img: IMG.rondineCastello,
          cardImg: IMG.rondineFleet,
          gallery: rondineGallery,
          specs: [
            { k: "Lunghezza", v: "22 metri" },
            { k: "Anno", v: "1924" },
            { k: "Cabine", v: "5" },
            { k: "Bagni", v: "2 con doccia" },
          ],
          features: [
            "5 cabine: 2 con letti a castello (2 posti), 2 con due letti singoli, 1 con due letti da una piazza e mezza",
            "2 bagni con doccia",
            "Salone con divanetto, tavolo e cucina",
            "Prua con prendisole e tavolo",
            "Poppa con tavolino",
            "Solarium in cima",
            "Scaletta reale per accesso a mare",
            "Doccetta di acqua dolce esterna",
          ],
          tours: [
            {
              tag: "Gruppo privato",
              name: "Tour Ischia — Gruppo Privato",
              desc: "Il giro completo dell'isola in esclusiva per il tuo gruppo, dalle 10 alle 17. Soste bagno, snorkeling e pranzo a bordo, con i tempi decisi da voi.",
              duration: "10:00 – 17:00 · gruppo privato",
              img: IMG.deck,
              bullets: ["Barca in esclusiva", "Bagno & snorkeling", "Pranzo a bordo"],
            },
            {
              tag: "Tour condiviso",
              name: "Tour Ischia — Condiviso",
              desc: "Il giro dell'isola prenotabile anche da singole persone: condividi la giornata con altri ospiti tra soste bagno, snorkeling e pranzo a bordo.",
              duration: "Prenotabile anche da 1 persona",
              img: IMG.rondineBreakfast,
              bullets: ["Prenotabile da 1 persona", "Bagno & snorkeling", "Pranzo a bordo"],
            },
          ],
          cruises: cruisesIT,
        },
        {
          slug: "rondinella",
          name: "Rondinella",
          tag: "Lancia Milano Aprea · 9 metri in legno",
          desc: "Una lancia Milano Aprea da nove metri in legno, agile ed elegante. Perfetta per uscite più intime e per raggiungere le calette più riservate dell'isola.",
          img: IMG.rondinellaCoupleHD,
          cardImg: IMG.rondinellaFleet,
          gallery: rondinellaGallery,
          specs: [
            { k: "Modello", v: "Lancia Milano Aprea" },
            { k: "Lunghezza", v: "9 metri" },
            { k: "Materiale", v: "Legno" },
            { k: "Ideale per", v: "Uscite intime" },
          ],
          features: [
            "Ampio prendisole di prua",
            "Plancetta di poppa con scala per salire e scendere dal mare",
            "Doccetta acqua dolce estraibile",
            "Frigo igloo",
          ],
          tours: [
            {
              tag: "Intera giornata",
              name: "Tour Intera Giornata — Ischia",
              desc: "Il giro dell'isola d'Ischia dalle 10 alle 17, con aperitivo a bordo. Bagni nelle calette più belle e relax sotto il sole.",
              duration: "10:00 – 17:00 · con aperitivo",
              img: IMG.rondinellaCruise,
              bullets: ["Giornata intera", "Bagno nelle calette", "Aperitivo a bordo"],
            },
            {
              tag: "Mezza giornata",
              name: "Tour Mezza Giornata — Ischia",
              desc: "Mezza giornata in mare, dalle 10 alle 13 o dalle 14 alle 17, con aperitivo a bordo. Ideale per chi ha poco tempo.",
              duration: "10–13 o 14–17 · con aperitivo",
              img: IMG.rondinellaCastello,
              bullets: ["Mattina o pomeriggio", "Bagno & relax", "Aperitivo a bordo"],
            },
            {
              tag: "Tramonto",
              name: "Aperitivo al Tramonto",
              desc: "Dalle 18 alle 21 salpiamo per un aperitivo in mare tra i colori del tramonto sul Golfo. L'esperienza più romantica per coppie e piccoli gruppi.",
              duration: "18:00 – 21:00",
              img: IMG.rondinellaSunset,
              bullets: ["Aperitivo & bollicine a bordo", "Luce del tramonto sul mare", "Ideale per coppie"],
              featured: true,
            },
          ],
        },
      ],
    },
    boatPage: {
      back: "Torna alle barche",
      aboard: "A bordo",
      excursionsTitle: "Le escursioni",
      excursionsSub: "Le esperienze disponibili su questa imbarcazione.",
      featuredLabel: "Più richiesto",
      specsTitle: "Caratteristiche",
      galleryTitle: "Galleria",
      book: "Prenota su WhatsApp",
    },
    itineraries: {
      overline: "Rotte d'autore",
      title: "I luoghi che tocchiamo",
      items: [
        { n: "01", name: "Isola d'Ischia", desc: "Il giro completo dell'isola: Sant'Angelo, la Baia di Sorgeto e le calette più belle." },
        { n: "02", name: "Procida - Capri", desc: "Il borgo pastello di Corricella e i celebri Faraglioni di Capri." },
        { n: "03", name: "Ventotene, Ponza e Palmarola", desc: "Grotte, faraglioni e acque cristalline dell'arcipelago pontino." },
        { n: "04", name: "Costiera Amalfitana e Sorrento", desc: "Le scogliere e i borghi affacciati sul mare tra Sorrento e Amalfi." },
      ],
    },
    story: {
      overline: "La nostra storia",
      chapters: [
        { n: "01", title: "Radici isolane", text: "Nasciamo a Ischia da una famiglia di marinai. Il mare non è un mestiere: è il modo in cui guardiamo il mondo." },
        { n: "02", title: "Il legno & il tempo", text: "La Rondine, del 1924, è stata riportata al suo splendore originale: una barca in legno che racconta un secolo di marineria." },
        { n: "03", title: "Piccoli o grandi gruppi", text: "Tour privati o condivisi, ritmi calmi, il tempo di un tuffo in più. Con uno chef a bordo, vi accogliamo come si accoglie un amico." },
      ],
    },
    contact: {
      overline: "Salpiamo insieme",
      title: "Prenota la tua giornata in mare",
      desc: "Scrivici su WhatsApp: ti rispondiamo con disponibilità, itinerario e preventivo su misura.",
      cta: "Scrivici su WhatsApp",
      location: "Porto d'Ischia · Napoli, Italia",
      follow: "Seguici",
    },
    reviews: {
      overline: "Dicono di noi",
      title: "Le recensioni dei nostri ospiti",
      list: [
        {
          name: "Giulia M.",
          origin: "Milano",
          text: "Giornata indimenticabile. La barca in legno è splendida e l'equipaggio ci ha fatto scoprire calette che da terra non avremmo mai visto. Aperitivo al tramonto da sogno.",
        },
        {
          name: "Marco & Elena",
          origin: "Roma",
          text: "Abbiamo festeggiato il nostro anniversario con la mini crociera verso Procida e Capri. Professionali, discreti e attentissimi. Torneremo di sicuro.",
        },
        {
          name: "Thomas W.",
          origin: "München",
          text: "The best day of our holiday in Ischia. Crystal clear water, great snorkeling stops and a fantastic lunch on board. Highly recommended!",
        },
        {
          name: "Francesca R.",
          origin: "Napoli",
          text: "Organizzazione impeccabile dalla prenotazione su WhatsApp fino allo sbarco. Barca curata nei minimi dettagli, capitano gentilissimo. Cinque stelle meritate.",
        },
      ],
    },
    footer: { rights: "Tutti i diritti riservati", tagline: "Noleggio barche · Ischia" },
    waMsg: "Ciao La Rondine Charter! Vorrei informazioni per prenotare un'esperienza in barca a Ischia.",
    legal: {
      privacyLink: "Privacy & Cookie",
      cookie: {
        text: "Questo sito utilizza cookie tecnici e strumenti di analisi per migliorare la tua esperienza di navigazione.",
        accept: "Accetta",
        more: "Maggiori informazioni",
      },
      privacy: {
        title: "Privacy & Cookie Policy",
        updated: "Ultimo aggiornamento: febbraio 2026",
        back: "Torna al sito",
        sections: [
          {
            h: "Titolare del trattamento",
            p: "La Rondine Charter — Rondine S.r.l., Porto d'Ischia, Napoli (Italia). P.IVA 08724351211. Contatti: WhatsApp +39 388 695 7133, email larondinecharter@gmail.com.",
          },
          {
            h: "Dati raccolti",
            p: "Questo sito è puramente vetrina e non contiene moduli di contatto. Non raccogliamo direttamente dati personali tramite il sito. Le richieste di prenotazione avvengono tramite l'applicazione esterna WhatsApp, soggetta alla propria informativa privacy.",
          },
          {
            h: "Cookie e strumenti di analisi",
            p: "Utilizziamo cookie tecnici necessari al funzionamento del sito e strumenti di analisi aggregata per comprendere l'utilizzo delle pagine e migliorare il servizio. Puoi gestire i cookie dalle impostazioni del tuo browser.",
          },
          {
            h: "Servizi di terze parti",
            p: "Il sito include collegamenti a servizi esterni: WhatsApp, Facebook e Instagram. Interagendo con tali collegamenti verrai reindirizzato a piattaforme di terze parti che trattano i dati secondo le proprie policy.",
          },
          {
            h: "Diritti dell'interessato",
            p: "Ai sensi del GDPR (Reg. UE 2016/679) hai diritto di accesso, rettifica, cancellazione e opposizione al trattamento dei tuoi dati. Per esercitare tali diritti contattaci ai recapiti indicati sopra.",
          },
        ],
      },
    },
  },
  en: {
    nav: { fleet: "The Boats", itineraries: "Itineraries", story: "Story", contact: "Contact", book: "Book" },
    hero: {
      overline: "Ischia · Gulf of Naples",
      titleLines: ["Step aboard.", "Let time slow down."],
      sub: "Ischia Boat Tours & Mini Cruises | La Rondine Charter",
      cta: "Book on WhatsApp",
      scroll: "Discover more",
    },
    marquee: ["Ischia tour", "Shared tours", "Sunset aperitivo", "Mini cruises", "Wooden boats", "Snorkeling"],
    fleet: {
      overline: "Charter · Ischia",
      title: "Our boats",
      subtitle: "Choose your vessel and discover all the experiences we can offer.",
      discover: "Discover the tours",
      boats: [
        {
          slug: "rondine",
          name: "La Rondine",
          tag: "22 meters · 1924",
          desc: "A vintage wooden vessel from 1924, restored and cared for in every detail. Spacious and welcoming for day tours and mini cruises in the Gulf of Naples.",
          img: IMG.rondineCastello,
          cardImg: IMG.rondineFleet,
          gallery: rondineGallery,
          specs: [
            { k: "Length", v: "22 meters" },
            { k: "Year", v: "1924" },
            { k: "Cabins", v: "5" },
            { k: "Bathrooms", v: "2 with shower" },
          ],
          features: [
            "5 cabins: 2 with bunk beds (2 berths), 2 with two single beds, 1 with two three-quarter beds",
            "2 bathrooms with shower",
            "Saloon with sofa, table and galley",
            "Bow with sun pad and table",
            "Stern with a small table",
            "Sun deck on top",
            "Real ladder for sea access",
            "External freshwater shower",
          ],
          tours: [
            {
              tag: "Private group",
              name: "Ischia Tour — Private Group",
              desc: "A full island tour exclusively for your group, from 10am to 5pm. Swim stops, snorkeling and lunch on board, at your own pace.",
              duration: "10:00 – 17:00 · private group",
              img: IMG.deck,
              bullets: ["Exclusive boat", "Swim & snorkeling", "Lunch on board"],
            },
            {
              tag: "Shared tour",
              name: "Ischia Tour — Shared",
              desc: "The island tour, bookable also for single guests: share the day with other guests between swim stops, snorkeling and lunch on board.",
              duration: "Bookable from 1 person",
              img: IMG.rondineBreakfast,
              bullets: ["Bookable from 1 person", "Swim & snorkeling", "Lunch on board"],
            },
          ],
          cruises: cruisesEN,
        },
        {
          slug: "rondinella",
          name: "Rondinella",
          tag: "Lancia Milano Aprea · 9 meters, wood",
          desc: "A nine-meter wooden Lancia Milano Aprea, agile and elegant. Perfect for more intimate outings and reaching the island's most secluded coves.",
          img: IMG.rondinellaCoupleHD,
          cardImg: IMG.rondinellaFleet,
          gallery: rondinellaGallery,
          specs: [
            { k: "Model", v: "Lancia Milano Aprea" },
            { k: "Length", v: "9 meters" },
            { k: "Material", v: "Wood" },
            { k: "Ideal for", v: "Intimate outings" },
          ],
          features: [
            "Large bow sun pad",
            "Stern platform with ladder for sea access",
            "Extractable fresh-water shower",
            "Igloo fridge",
          ],
          tours: [
            {
              tag: "Full day",
              name: "Full Day Tour — Ischia",
              desc: "The Ischia island tour from 10am to 5pm, with aperitivo on board. Swims in the most beautiful coves and relaxation in the sun.",
              duration: "10:00 – 17:00 · with aperitivo",
              img: IMG.rondinellaCruise,
              bullets: ["Full day", "Swims in the coves", "Aperitivo on board"],
            },
            {
              tag: "Half day",
              name: "Half Day Tour — Ischia",
              desc: "Half a day at sea, 10am–1pm or 2pm–5pm, with aperitivo on board. Ideal for those short on time.",
              duration: "10–13 or 14–17 · with aperitivo",
              img: IMG.rondinellaCastello,
              bullets: ["Morning or afternoon", "Swim & relax", "Aperitivo on board"],
            },
            {
              tag: "Sunset",
              name: "Sunset Aperitivo",
              desc: "From 6pm to 9pm we set sail for an aperitivo at sea among the colours of sunset over the Gulf. The most romantic experience for couples and small groups.",
              duration: "18:00 – 21:00",
              img: IMG.rondinellaSunset,
              bullets: ["Aperitivo & bubbles on board", "Sunset light over the sea", "Perfect for couples"],
              featured: true,
            },
          ],
        },
      ],
    },
    boatPage: {
      back: "Back to the boats",
      aboard: "Aboard",
      excursionsTitle: "The tours",
      excursionsSub: "The experiences available on this vessel.",
      featuredLabel: "Most popular",
      specsTitle: "Specifications",
      galleryTitle: "Gallery",
      book: "Book on WhatsApp",
    },
    itineraries: {
      overline: "Signature routes",
      title: "The places we reach",
      items: [
        { n: "01", name: "Ischia Island", desc: "The full island tour: Sant'Angelo, Sorgeto Bay and the most beautiful coves." },
        { n: "02", name: "Procida - Capri", desc: "The pastel village of Corricella and the famous Faraglioni of Capri." },
        { n: "03", name: "Ventotene, Ponza & Palmarola", desc: "Caves, sea stacks and crystal-clear waters of the Pontine archipelago." },
        { n: "04", name: "Amalfi Coast & Sorrento", desc: "Cliffs and seaside villages between Sorrento and Amalfi." },
      ],
    },
    story: {
      overline: "Our story",
      chapters: [
        { n: "01", title: "Island roots", text: "Born in Ischia to a family of sailors. The sea isn't a job: it's how we look at the world." },
        { n: "02", title: "Wood & time", text: "La Rondine, built in 1924, was brought back to its original splendour: a wooden boat telling a century of seafaring." },
        { n: "03", title: "Small or large groups", text: "Private or shared tours, a calm pace, time for one more dive. With a chef on board, we host you the way you'd welcome a friend." },
      ],
    },
    contact: {
      overline: "Let's set sail",
      title: "Book your day at sea",
      desc: "Message us on WhatsApp: we'll reply with availability, itinerary and a tailor-made quote.",
      cta: "Message us on WhatsApp",
      location: "Ischia Harbour · Naples, Italy",
      follow: "Follow us",
    },
    reviews: {
      overline: "What they say",
      title: "Reviews from our guests",
      list: [
        {
          name: "Giulia M.",
          origin: "Milan",
          text: "An unforgettable day. The wooden boat is stunning and the crew showed us coves we would never have found from land. A dreamy sunset aperitivo.",
        },
        {
          name: "Marco & Elena",
          origin: "Rome",
          text: "We celebrated our anniversary with the mini cruise to Procida and Capri. Professional, discreet and very attentive. We will definitely come back.",
        },
        {
          name: "Thomas W.",
          origin: "Munich",
          text: "The best day of our holiday in Ischia. Crystal clear water, great snorkeling stops and a fantastic lunch on board. Highly recommended!",
        },
        {
          name: "Francesca R.",
          origin: "Naples",
          text: "Flawless organization from the WhatsApp booking to disembarkation. A boat cared for in every detail, a lovely captain. Five well-deserved stars.",
        },
      ],
    },
    footer: { rights: "All rights reserved", tagline: "Boat charter · Ischia" },
    waMsg: "Hi La Rondine Charter! I'd like information to book a boat experience in Ischia.",
    legal: {
      privacyLink: "Privacy & Cookies",
      cookie: {
        text: "This site uses technical cookies and analytics tools to improve your browsing experience.",
        accept: "Accept",
        more: "Learn more",
      },
      privacy: {
        title: "Privacy & Cookie Policy",
        updated: "Last updated: February 2026",
        back: "Back to site",
        sections: [
          {
            h: "Data controller",
            p: "La Rondine Charter — Rondine S.r.l., Ischia Harbour, Naples (Italy). VAT 08724351211. Contact: WhatsApp +39 388 695 7133, email larondinecharter@gmail.com.",
          },
          {
            h: "Data we collect",
            p: "This is a showcase website with no contact forms. We do not directly collect personal data through the site. Booking requests happen via the external WhatsApp app, subject to its own privacy policy.",
          },
          {
            h: "Cookies and analytics",
            p: "We use technical cookies necessary for the site to function and aggregated analytics tools to understand page usage and improve the service. You can manage cookies from your browser settings.",
          },
          {
            h: "Third-party services",
            p: "The site links to external services: WhatsApp, Facebook and Instagram. By interacting with these links you will be redirected to third-party platforms that process data according to their own policies.",
          },
          {
            h: "Your rights",
            p: "Under the GDPR (EU Reg. 2016/679) you have the right to access, rectify, erase and object to the processing of your data. To exercise these rights, contact us using the details above.",
          },
        ],
      },
    },
  },
};
